import { CheckoutType, Product } from '@gik/core/models/gik/Product';
import { openExternalLink } from '@gik/core/utils/browser';
import { UI } from '@gik/ui';
import { CartItem } from '../types';

/**
 * Determine if a product is a TangoCard product
 */
export function productIsTangoCard(product: Product) {
  return product.checkoutType === CheckoutType.TangoCard;
}

/**
 * Determine if a product can be purchased in-site
 */
export function productHasIntegratedCheckout(product: Product) {
  return (
    product.checkoutType === CheckoutType.TangoCard ||
    product.checkoutType === CheckoutType.Giftbox ||
    product.checkoutType === CheckoutType.VirtualProduct ||
    product.checkoutType === CheckoutType.GikPremium
  );
}
/**
 * Display product affiliate note
 */
export function productHasAffiliateRelationship(product: Product) {
  return product.checkoutType === CheckoutType.TangoCard || product.checkoutType === CheckoutType.VirtualProduct;
}

/**
 * Show source info for affiliate product
 */
export function productIsAffiliate(product: Product) {
  return !productIsTangoCard(product) && !product.isInternalProduct;
}

/**
 * Translates a payment method name into a human friendly string
 * TODO: this should be translated through i18n
 */
export function parsePaymentMethodName(paymentMethod: string): string {
  switch (paymentMethod) {
    case 'stripe':
      return 'Credit Card (Stripe)';
    default:
      return 'Unknown';
  }
}

/**
 * Open an affiliate product link
 */
export function openNonD2CUrl(productNonD2CUrl: string) {
  openExternalLink(productNonD2CUrl);
}

/**
 * Triggered when a user tries to purchase a product from an affiliate link that does not exist
 */
export function alertNoNonD2CUrlAvailable() {
  console.error('No non-d2c URL for product');
  UI.alert('Unfortunately this product cannot be purchased right now.');
}

export function createCartItemFromProduct(product: Product): CartItem {
  if (!product) {
    return undefined;
  }
  const cartItem: CartItem = {
    price: product.price > 0 ? product.price : undefined,
    productId: product.id,
    quantity: 1,
    name: product.name,
    checkoutType: product.checkoutType,
    groupedProductIds: product.groupedProductIds,
  };
  if (product.variations && product.variations.length === 1) {
    cartItem.variationId = product.variations[0].id;
  }
  return cartItem;
}
